/* Info component on the ProfilesPage */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info = () => {
  return (
    <div>
        <Row className='mb-3'>
            <Col className={`px-3 py-2 ${styles.SubTitle6 }`} md={{span: 8, offset: 2 }}>
            <p className={`${styles.Red} text-center`}>PROFILES PAGE INFO</p>
            <hr className={`mt-2 mb-0`}/>
            <p><span className={`${styles.Red}`}>*</span> Click on a Profile's <span className={`${styles.Red}`}>Follow</span> button to add them to 
                your feed.
           </p>
           <p><span className={`${styles.Red}`}>*</span> Click on a Profile to view the Crew members Scenes Workshop Posts.
           </p>
           <p className={`${styles.Small} pt-3`}> Note: Click on your Profile below
            or the My Profile link to open your Profile page to change your Password and add your Position.
           </p>
           <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default Info